export class Ship {
  public id: number;
  public name: string;
  public code: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class Stock {
  public id: number;
  public name: string;
  public pseudonym: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class QuotaItem {
  public id: number;
  public name: string;
  public quota_type: string;
  public stock: Stock;
  public ships: Ship[] = [];

  public label: string;

  constructor(values: Object = {}) {
    this.id = values['id'];
    this.name = values['name'];
    this.quota_type = values['quota_type'];

    if (values['stock']) {
      this.stock = new Stock(values['stock']);
    }

    if (values['ships']) {
      for (const ship of values['ships']) {
        this.ships.push(new Ship(ship));
      }
    }

    this.setLabel();
  }

  public setLabel() {
    if (this.quota_type === 'multiple') {
      this.label = this.name;
    } else {
      this.label = `${this.ships[0] && this.ships[0].name} (${this.ships[0] && this.ships[0].code})`;
    }
  }
}

export class OptionMapper {
  value: string;
  display_name: string;

  public static generateCollectionFromApi(rawTypes) {
    const collection = [];

    for (const object of rawTypes) {
      collection.push(new this(object));
    }

    return collection;
  }

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

  apiMap(values: Object = {}) {
    return new OptionMapper(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/pojos.ts